import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PortfolioFilterType } from '../../../../../enums/PortfolioFilterType';
import { usePortfolioFilter } from '../../../../../hooks/UsePortfolioFilter';
import { AppState } from '../../../../../store/AppState';
import { setOpenFilterCount } from '../../../../../store/portfolio/PortfolioActions';
import { PortfolioState } from '../../../../../store/portfolio/PortfolioReducer';
import RangeDropdown from '../../../../shared/filters/range-dropdown/RangeDropdown';

const PortfolioUpdatedFilter: FC = () => {
  const { setSelectedFilter, updateDefaultLastUpdated, getPortfolioView } = usePortfolioFilter();
  const { dealType, openFilterCount } = useSelector<AppState, PortfolioState>(
    (portfolioState) => portfolioState.portfolio,
  );

  const currentView = getPortfolioView(dealType);
  const dispatch = useDispatch();

  const onOpen = () => {
    const newOpenFilterCount = openFilterCount + 1;
    dispatch(setOpenFilterCount(newOpenFilterCount));
  };
  const onClose = () => {
    const newOpenFilterCount = openFilterCount === 0 ? 0 : openFilterCount - 1;
    dispatch(setOpenFilterCount(newOpenFilterCount));
  };

  useEffect(() => {
    updateDefaultLastUpdated(currentView?.filters.minDate, currentView?.filters.maxDate, dealType);
  }, [currentView?.filters.minDate, currentView?.filters.maxDate]);

  return (
    <div data-testid='portfolio-updated-filter'>
      <RangeDropdown
        type='am-label'
        displayLabel={'Updated'}
        bottomLabelText={' D'}
        maxLength={4}
        selectedValue={currentView?.selectedFilters.lastUpdated}
        possibleRange={currentView?.defaultLastUpdated}
        onChange={(value) => setSelectedFilter(PortfolioFilterType.LastUpdate, value, dealType)}
        onOpen={onOpen}
        onClose={onClose}
        cssClass='exclude-sorting'
        optionsLeft={-80}
      />
    </div>
  );
};

export default PortfolioUpdatedFilter;
